module.exports = __webpack_public_path__ + "img/login3.0891cbc4.png";